// Shared between the dealer's Track order page and the super admin's
// Orders page so a given status always reads the same everywhere.
export const ORDER_STATUS_LABEL = {
  pending: "Pending",
  accepted: "Accepted",
  rejected: "Rejected",
  making: "Making",
  delivery: "Out for delivery",
  delivered: "Delivered",
};

// Amber = actively being worked on, so it reads as "in progress" at a
// glance — a warm, muted amber rather than a harsh pure orange or a
// hard-to-see yellow. Distinct from "just requested" (neutral) and the two
// terminal states (green = done, red = rejected).
const IN_PROGRESS = new Set(["accepted", "making", "delivery"]);

export function isOrderInProgress(status) {
  return IN_PROGRESS.has(status);
}

export function orderStatusTextClass(status) {
  if (status === "delivered") return "text-kl-greenDark";
  if (status === "rejected") return "text-kl-inactive";
  if (IN_PROGRESS.has(status)) return "text-amber-600";
  return "text-kl-mutedLight";
}

export function orderStatusBadgeClass(status) {
  if (status === "delivered") return "border-kl-green text-kl-greenDark";
  if (status === "rejected") return "border-kl-inactive text-kl-inactive";
  if (IN_PROGRESS.has(status)) return "border-amber-400 text-amber-600";
  return "border-kl-line text-kl-muted";
}

export function orderStatusDotClass(status) {
  if (status === "delivered") return "bg-kl-green";
  if (status === "rejected") return "bg-kl-inactive";
  if (IN_PROGRESS.has(status)) return "bg-amber-500";
  return "bg-kl-mutedLight";
}
